import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import IconButton from "@material-ui/core/IconButton";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

import useStyles from "./styles";

type TEntity = racehorse360.IWorkout | racehorse360.IRaceHistory;

interface IProps {
  className?: string;
  entity?: TEntity;
  onOpenMedia: (event: React.MouseEvent, entity?: TEntity) => void;
  isDisabled: boolean;
}

const MediaPlayButton = (props: IProps) => {
  const { entity, onOpenMedia, isDisabled, className } = props;
  const classes = useStyles();

  const handleOpenVideo = (event: React.MouseEvent) => {
    onOpenMedia(event, entity);
  };

  return (
    <div className={className}>
      <IconButton size="small" onClick={handleOpenVideo} disabled={isDisabled}>
        <PlayArrowIcon
          className={clsx(classes.icon, {
            [classes.iconActive]: !isDisabled
          })}
        />
      </IconButton>
    </div>
  );
};

export default MediaPlayButton;
